export default __webpack_public_path__ + "static/Metal_Ramp-51babfadd2841658ba2f10ed66077072.png";